import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"me-7 mb-4\"><div class=\"symbol symbol-100px symbol-lg-160px symbol-fixed position-relative\"><span class=\"fw-bold d-block pt-1\"><template><span class=\"fw-bold d-block pt-1 mt-5\"><i class=\"fa fa-book fa-4x\" aria-hidden=\"true\"></i></span></template></span></div></div>", 1)
const _hoisted_5 = { class: "flex-grow-1 m-auto" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "d-flex align-items-center mb-2" }
const _hoisted_9 = { class: "text-gray-800 text-hover-primary fs-3 fw-bolder me-1" }
const _hoisted_10 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_11 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_12 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Entity: ", -1)
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_15 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Course Type: ", -1)
const _hoisted_18 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_19 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_20 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Course Code: ", -1)
const _hoisted_22 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_23 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_31 = {
  key: 0,
  class: "card"
}
const _hoisted_32 = { class: "" }
const _hoisted_33 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_34 = {
  class: "mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_35 = { class: "card-toolbar" }
const _hoisted_36 = {
  key: 0,
  class: "d-flex justify-content-end px-8",
  "data-kt-infos-table-toolbar": "base"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_38 = { class: "card-body p-9" }
const _hoisted_39 = { class: "row mb-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Course Name", -1)
const _hoisted_41 = { class: "col-lg-8" }
const _hoisted_42 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_43 = { class: "row mb-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Tranche", -1)
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = { class: "fw-bold fs-6" }
const _hoisted_47 = { class: "row mb-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Association", -1)
const _hoisted_49 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_50 = { class: "fw-bold fs-6 me-2" }
const _hoisted_51 = { class: "row mb-2" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Course Type", -1)
const _hoisted_53 = { class: "col-lg-8" }
const _hoisted_54 = { class: "fw-bold fs-6 me-2" }
const _hoisted_55 = { class: "row mb-2" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Course Sector ", -1)
const _hoisted_57 = { class: "col-lg-8" }
const _hoisted_58 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_59 = { class: "row mb-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Code", -1)
const _hoisted_61 = { class: "col-lg-8" }
const _hoisted_62 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_63 = { class: "row mb-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Unique Course Name", -1)
const _hoisted_65 = { class: "col-lg-8" }
const _hoisted_66 = { class: "fw-bold fs-6" }
const _hoisted_67 = { class: "row mb-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Total Target Batch", -1)
const _hoisted_69 = { class: "col-lg-8" }
const _hoisted_70 = { class: "fw-bold fs-6" }
const _hoisted_71 = { class: "row mb-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Trainee Per Batch", -1)
const _hoisted_73 = { class: "col-lg-8" }
const _hoisted_74 = { class: "fw-bold fs-6" }
const _hoisted_75 = { class: "row mb-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Min Day Per Month", -1)
const _hoisted_77 = { class: "col-lg-8" }
const _hoisted_78 = { class: "fw-bold fs-6" }
const _hoisted_79 = { class: "row mb-2" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Total Course Cost", -1)
const _hoisted_81 = { class: "col-lg-8" }
const _hoisted_82 = { class: "fw-bold fs-6" }
const _hoisted_83 = { class: "row mb-2" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Course Unit Cost", -1)
const _hoisted_85 = { class: "col-lg-8" }
const _hoisted_86 = { class: "fw-bold fs-6" }
const _hoisted_87 = { class: "row mb-2" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Total Target Trainee:", -1)
const _hoisted_89 = { class: "col-lg-8" }
const _hoisted_90 = { class: "fw-bold fs-6" }
const _hoisted_91 = { class: "row mb-2" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Min Age:", -1)
const _hoisted_93 = { class: "col-lg-8" }
const _hoisted_94 = { class: "fw-bold fs-6" }
const _hoisted_95 = { class: "row mb-2" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Max Age:", -1)
const _hoisted_97 = { class: "col-lg-8" }
const _hoisted_98 = { class: "fw-bold fs-6" }
const _hoisted_99 = { class: "row mb-2" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Course Objective:", -1)
const _hoisted_101 = { class: "col-lg-8" }
const _hoisted_102 = { class: "fw-bold fs-6" }
const _hoisted_103 = { class: "row mb-2" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Entry Qualification:", -1)
const _hoisted_105 = { class: "col-lg-8" }
const _hoisted_106 = { class: "fw-bold fs-6" }
const _hoisted_107 = { class: "row mb-2" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Month:", -1)
const _hoisted_109 = { class: "col-lg-8" }
const _hoisted_110 = { class: "fw-bold fs-6" }
const _hoisted_111 = { class: "row mb-2" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Hour:", -1)
const _hoisted_113 = { class: "col-lg-8" }
const _hoisted_114 = { class: "fw-bold fs-6" }
const _hoisted_115 = { class: "row mb-2" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Day:", -1)
const _hoisted_117 = { class: "col-lg-8" }
const _hoisted_118 = { class: "fw-bold fs-6" }
const _hoisted_119 = { class: "row mb-2" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Session:", -1)
const _hoisted_121 = { class: "col-lg-8" }
const _hoisted_122 = { class: "fw-bold fs-6" }
const _hoisted_123 = { class: "row mb-2" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Term:", -1)
const _hoisted_125 = { class: "col-lg-8" }
const _hoisted_126 = { class: "fw-bold fs-6" }
const _hoisted_127 = { class: "row mb-2" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Is Stipend Course:", -1)
const _hoisted_129 = { class: "col-lg-8" }
const _hoisted_130 = { class: "fw-bold fs-6" }
const _hoisted_131 = { class: "row mb-2" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Skills Level:", -1)
const _hoisted_133 = { class: "col-lg-8" }
const _hoisted_134 = { class: "fw-bold fs-6" }
const _hoisted_135 = { class: "row mb-2" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Is Management Course ? :", -1)
const _hoisted_137 = { class: "col-lg-8" }
const _hoisted_138 = { class: "fw-bold fs-6" }
const _hoisted_139 = { class: "row mb-2" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Is Employment Eligible:", -1)
const _hoisted_141 = { class: "col-lg-8" }
const _hoisted_142 = { class: "fw-bold fs-6" }
const _hoisted_143 = { class: "row mb-2" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Is Reassessment Enabled:", -1)
const _hoisted_145 = { class: "col-lg-8" }
const _hoisted_146 = { class: "fw-bold fs-6" }
const _hoisted_147 = { class: "row mb-2" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Is Tot Course:", -1)
const _hoisted_149 = { class: "col-lg-8" }
const _hoisted_150 = { class: "fw-bold fs-6" }
const _hoisted_151 = { class: "row mb-2" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Is Advanced Course:", -1)
const _hoisted_153 = { class: "col-lg-8" }
const _hoisted_154 = { class: "fw-bold fs-6" }
const _hoisted_155 = { class: "row mb-2" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Certification Authority:", -1)
const _hoisted_157 = { class: "col-lg-8" }
const _hoisted_158 = { class: "fw-bold fs-6" }
const _hoisted_159 = {
  key: 1,
  class: "card"
}
const _hoisted_160 = { class: "card-body" }
const _hoisted_161 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_162 = {
  class: "mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_163 = { class: "card-toolbar" }
const _hoisted_164 = {
  key: 0,
  class: "d-flex justify-content-end px-8",
  "data-kt-infos-table-toolbar": "base"
}
const _hoisted_165 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_167 = { class: "card-body p-9" }
const _hoisted_168 = { class: "row mb-2" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Employemnt Bill Claim %", -1)
const _hoisted_170 = { class: "col-lg-8" }
const _hoisted_171 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_172 = { class: "row mb-2" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Enrollment Grace (day)", -1)
const _hoisted_174 = { class: "col-lg-8 fv-row" }
const _hoisted_175 = { class: "fw-bold fs-6" }
const _hoisted_176 = { class: "row mb-2" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Replacement % ", -1)
const _hoisted_178 = { class: "col-lg-8" }
const _hoisted_179 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_180 = { class: "row mb-2" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Employemnt Bill Claim %", -1)
const _hoisted_182 = { class: "col-lg-8" }
const _hoisted_183 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_184 = { class: "row mb-2" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Assessment Applicable?", -1)
const _hoisted_186 = { class: "col-lg-8" }
const _hoisted_187 = { class: "fw-bold fs-6" }
const _hoisted_188 = { class: "row mb-2" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Certification Applicable", -1)
const _hoisted_190 = { class: "col-lg-8" }
const _hoisted_191 = { class: "fw-bold fs-6" }
const _hoisted_192 = {
  key: 2,
  class: "card"
}
const _hoisted_193 = { class: "card-body" }
const _hoisted_194 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_195 = { class: "mb-5 mb-xl-10" }
const _hoisted_196 = { class: "row" }
const _hoisted_197 = { class: "card-toolbar" }
const _hoisted_198 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-infos-table-toolbar": "base"
}
const _hoisted_199 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Course Term")
], -1)
const _hoisted_202 = { class: "card mb-5 mb-xl-10" }
const _hoisted_203 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_204 = {
  id: "course_term",
  class: "collapse show"
}
const _hoisted_205 = { class: "collapse show" }
const _hoisted_206 = { class: "card-body border-top p-5" }
const _hoisted_207 = { class: "row" }
const _hoisted_208 = { class: "col-md-1" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term ", -1)
const _hoisted_210 = { class: "col-md-2" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Month ", -1)
const _hoisted_212 = { class: "col-md-1" }
const _hoisted_213 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Day", -1)
const _hoisted_214 = { class: "col-md-1" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session", -1)
const _hoisted_216 = { class: "col-md-2" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Hour", -1)
const _hoisted_218 = { class: "col-md-2" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Class Type", -1)
const _hoisted_220 = ["onUpdate:modelValue"]
const _hoisted_221 = /*#__PURE__*/_createElementVNode("option", {
  label: "Class Work",
  value: "1"
}, " Class Work ", -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("option", {
  label: "Internship",
  value: "2"
}, " Internship ", -1)
const _hoisted_223 = [
  _hoisted_221,
  _hoisted_222
]
const _hoisted_224 = { class: "col-md-2" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session Per Week", -1)
const _hoisted_226 = {
  key: 3,
  class: "card"
}
const _hoisted_227 = { class: "card-body" }
const _hoisted_228 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_229 = { class: "mb-5 mb-xl-10" }
const _hoisted_230 = { class: "row" }
const _hoisted_231 = { class: "card-toolbar" }
const _hoisted_232 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-infos-table-toolbar": "base"
}
const _hoisted_233 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_234 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_235 = /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Course Bill")
], -1)
const _hoisted_236 = { class: "card mb-5 mb-xl-10 p-5" }
const _hoisted_237 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_238 = { class: "row mt-2" }
const _hoisted_239 = { class: "col-md-2" }
const _hoisted_240 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Claim", -1)
const _hoisted_241 = { class: "col-md-3" }
const _hoisted_242 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Milestone ", -1)
const _hoisted_243 = {
  key: 0,
  value: "EnrollMent",
  type: "string",
  class: "form-control form-control-sm",
  disabled: ""
}
const _hoisted_244 = {
  key: 1,
  value: "Assesment",
  type: "string",
  class: "form-control form-control-sm",
  disabled: ""
}
const _hoisted_245 = {
  key: 2,
  value: "Employment",
  type: "string",
  class: "form-control form-control-sm",
  disabled: ""
}
const _hoisted_246 = { class: "col-md-2" }
const _hoisted_247 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim%", -1)
const _hoisted_248 = { class: "col-md-3" }
const _hoisted_249 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Advance Adjustment %", -1)
const _hoisted_250 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Claim Cost")
  ])
], -1)
const _hoisted_251 = { class: "col-md-1" }
const _hoisted_252 = { class: "form-label" }
const _hoisted_253 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_254 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_255 = {
  key: 4,
  class: "card"
}
const _hoisted_256 = { class: "card-body" }
const _hoisted_257 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_258 = { class: "card-header border-0 pt-6 px-0 mx-0 mb-5" }
const _hoisted_259 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Course Chapters")
  ])
], -1)
const _hoisted_260 = { class: "card-toolbar" }
const _hoisted_261 = {
  class: "d-flex justify-content-end",
  "data-kt-infos-table-toolbar": "base"
}
const _hoisted_262 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_263 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"73.5vw","border-bottom":"2px solid #39cf26"} }, null, -1)
const _hoisted_264 = { class: "col-lg-12 p-2 mx-15 mt-3" }
const _hoisted_265 = { class: "fw-bold fs-6 text-muted" }
const _hoisted_266 = { class: "mx-3" }
const _hoisted_267 = {
  key: 5,
  class: "card"
}
const _hoisted_268 = { class: "card-body" }
const _hoisted_269 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_270 = { class: "card-header border-0 pt-6 px-0 mx-0 mb-5" }
const _hoisted_271 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Unit of Competency")
  ])
], -1)
const _hoisted_272 = { class: "card-toolbar" }
const _hoisted_273 = {
  class: "d-flex justify-content-end",
  "data-kt-infos-table-toolbar": "base"
}
const _hoisted_274 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_275 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"73.5vw","border-bottom":"2px solid #39cf26"} }, null, -1)
const _hoisted_276 = { class: "col-lg-12 p-2 mx-15 mt-3" }
const _hoisted_277 = { class: "fw-bold fs-6 text-muted" }
const _hoisted_278 = { class: "mx-3" }
const _hoisted_279 = { class: "card-body" }
const _hoisted_280 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_281 = { class: "mb-5" }
const _hoisted_282 = { class: "position-relative" }
const _hoisted_283 = { class: "card-body p-0" }
const _hoisted_284 = { class: "d-flex row" }
const _hoisted_285 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-4 pl-0" }, " Course Change Summery ")
], -1)
const _hoisted_286 = {
  key: 0,
  class: "col-md-6 text-end"
}
const _hoisted_287 = {
  key: 0,
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_288 = /*#__PURE__*/_createElementVNode("h3", null, "Course Information Change", -1)
const _hoisted_289 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_290 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Old Data"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "New Data")
  ])
], -1)
const _hoisted_291 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_292 = /*#__PURE__*/_createElementVNode("td", null, "Course Name", -1)
const _hoisted_293 = {
  key: 1,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_294 = /*#__PURE__*/_createElementVNode("td", null, "Course Type", -1)
const _hoisted_295 = {
  key: 2,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_296 = /*#__PURE__*/_createElementVNode("td", null, "Course Sector", -1)
const _hoisted_297 = {
  key: 3,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_298 = /*#__PURE__*/_createElementVNode("td", null, "Code", -1)
const _hoisted_299 = {
  key: 4,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_300 = /*#__PURE__*/_createElementVNode("td", null, "Unique Course Name", -1)
const _hoisted_301 = {
  key: 5,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_302 = /*#__PURE__*/_createElementVNode("td", null, "Total Target Batch", -1)
const _hoisted_303 = {
  key: 6,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_304 = /*#__PURE__*/_createElementVNode("td", null, "Trainee Per Batch", -1)
const _hoisted_305 = {
  key: 7,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_306 = /*#__PURE__*/_createElementVNode("td", null, "Min Day Per Month", -1)
const _hoisted_307 = {
  key: 8,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_308 = /*#__PURE__*/_createElementVNode("td", null, "Total Course Cost", -1)
const _hoisted_309 = {
  key: 9,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_310 = /*#__PURE__*/_createElementVNode("td", null, "Total Target Trainee", -1)
const _hoisted_311 = {
  key: 10,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_312 = /*#__PURE__*/_createElementVNode("td", null, "Min Age", -1)
const _hoisted_313 = {
  key: 11,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_314 = /*#__PURE__*/_createElementVNode("td", null, "Max Age", -1)
const _hoisted_315 = {
  key: 12,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_316 = /*#__PURE__*/_createElementVNode("td", null, "Course Objective", -1)
const _hoisted_317 = {
  key: 13,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_318 = /*#__PURE__*/_createElementVNode("td", null, "Entry Qualification", -1)
const _hoisted_319 = {
  key: 14,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_320 = /*#__PURE__*/_createElementVNode("td", null, "Month", -1)
const _hoisted_321 = {
  key: 15,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_322 = /*#__PURE__*/_createElementVNode("td", null, "Hour", -1)
const _hoisted_323 = {
  key: 16,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_324 = /*#__PURE__*/_createElementVNode("td", null, "Day", -1)
const _hoisted_325 = {
  key: 17,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_326 = /*#__PURE__*/_createElementVNode("td", null, "Session", -1)
const _hoisted_327 = {
  key: 18,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_328 = /*#__PURE__*/_createElementVNode("td", null, "Term", -1)
const _hoisted_329 = {
  key: 19,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_330 = /*#__PURE__*/_createElementVNode("td", null, "Is Stipend Course", -1)
const _hoisted_331 = {
  key: 20,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_332 = /*#__PURE__*/_createElementVNode("td", null, "Is Management Course", -1)
const _hoisted_333 = {
  key: 21,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_334 = /*#__PURE__*/_createElementVNode("td", null, "Is Employment Eligible", -1)
const _hoisted_335 = {
  key: 22,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_336 = /*#__PURE__*/_createElementVNode("td", null, "Is Reassessment Enabled", -1)
const _hoisted_337 = {
  key: 23,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_338 = /*#__PURE__*/_createElementVNode("td", null, "Is Tot Course", -1)
const _hoisted_339 = {
  key: 24,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_340 = /*#__PURE__*/_createElementVNode("td", null, "Certification Authority", -1)
const _hoisted_341 = {
  key: 1,
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_342 = /*#__PURE__*/_createElementVNode("h3", null, "Course Configuration Change", -1)
const _hoisted_343 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_344 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Old Data"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "New Data")
  ])
], -1)
const _hoisted_345 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_346 = /*#__PURE__*/_createElementVNode("td", null, "Enrollment Grace (day)", -1)
const _hoisted_347 = {
  key: 1,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_348 = /*#__PURE__*/_createElementVNode("td", null, "Replacement %", -1)
const _hoisted_349 = {
  key: 2,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_350 = /*#__PURE__*/_createElementVNode("td", null, "Employemnt Bill Claim %", -1)
const _hoisted_351 = {
  key: 3,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_352 = /*#__PURE__*/_createElementVNode("td", null, "Assessment Applicable?", -1)
const _hoisted_353 = {
  key: 4,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_354 = /*#__PURE__*/_createElementVNode("td", null, "Certification Applicable?", -1)
const _hoisted_355 = {
  key: 2,
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_356 = /*#__PURE__*/_createElementVNode("h3", null, "Course Term Change", -1)
const _hoisted_357 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_358 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Term"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Old Data"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "New Data")
  ])
], -1)
const _hoisted_359 = { style: {"border":"1px solid #1db78d"} }
const _hoisted_360 = ["rowspan"]
const _hoisted_361 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_362 = /*#__PURE__*/_createElementVNode("td", null, "Month", -1)
const _hoisted_363 = {
  key: 1,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_364 = /*#__PURE__*/_createElementVNode("td", null, "Day", -1)
const _hoisted_365 = {
  key: 2,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_366 = /*#__PURE__*/_createElementVNode("td", null, "Session", -1)
const _hoisted_367 = {
  key: 3,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_368 = /*#__PURE__*/_createElementVNode("td", null, "Hour", -1)
const _hoisted_369 = {
  key: 4,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_370 = /*#__PURE__*/_createElementVNode("td", null, "Class Type", -1)
const _hoisted_371 = {
  key: 5,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_372 = /*#__PURE__*/_createElementVNode("td", null, "Week Session", -1)
const _hoisted_373 = { style: {"border":"1px solid #1db78d"} }
const _hoisted_374 = { rowspan: 7 }
const _hoisted_375 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_376 = /*#__PURE__*/_createElementVNode("td", null, "Month", -1)
const _hoisted_377 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_378 = {
  key: 1,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_379 = /*#__PURE__*/_createElementVNode("td", null, "Day", -1)
const _hoisted_380 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_381 = {
  key: 2,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_382 = /*#__PURE__*/_createElementVNode("td", null, "Session", -1)
const _hoisted_383 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_384 = {
  key: 3,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_385 = /*#__PURE__*/_createElementVNode("td", null, "Hour", -1)
const _hoisted_386 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_387 = {
  key: 4,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_388 = /*#__PURE__*/_createElementVNode("td", null, "Class Type", -1)
const _hoisted_389 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_390 = {
  key: 5,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_391 = /*#__PURE__*/_createElementVNode("td", null, "Week Session", -1)
const _hoisted_392 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_393 = {
  key: 3,
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_394 = /*#__PURE__*/_createElementVNode("h3", null, "Course Bill Change", -1)
const _hoisted_395 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_396 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Old Data"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "New Data")
  ])
], -1)
const _hoisted_397 = { style: {"border":"1px solid #1db78d"} }
const _hoisted_398 = ["rowspan"]
const _hoisted_399 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_400 = /*#__PURE__*/_createElementVNode("td", null, "Claim", -1)
const _hoisted_401 = {
  key: 1,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_402 = /*#__PURE__*/_createElementVNode("td", null, "Training Milestone", -1)
const _hoisted_403 = {
  key: 2,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_404 = /*#__PURE__*/_createElementVNode("td", null, "Claim%", -1)
const _hoisted_405 = {
  key: 3,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_406 = /*#__PURE__*/_createElementVNode("td", null, "Advance Adjustment %", -1)
const _hoisted_407 = { style: {"border":"1px solid #1db78d"} }
const _hoisted_408 = { rowspan: 6 }
const _hoisted_409 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_410 = /*#__PURE__*/_createElementVNode("td", null, "Claim", -1)
const _hoisted_411 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_412 = {
  key: 1,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_413 = /*#__PURE__*/_createElementVNode("td", null, "Training Milestone", -1)
const _hoisted_414 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_415 = {
  key: 2,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_416 = /*#__PURE__*/_createElementVNode("td", null, "Claim%", -1)
const _hoisted_417 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_418 = {
  key: 3,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_419 = /*#__PURE__*/_createElementVNode("td", null, "Advance Adjustment %", -1)
const _hoisted_420 = /*#__PURE__*/_createElementVNode("td", null, "New Data", -1)
const _hoisted_421 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_CourseInfoDrawer = _resolveComponent("CourseInfoDrawer")!
  const _component_CourseConfigDrawer = _resolveComponent("CourseConfigDrawer")!
  const _component_CourseTermDrawer = _resolveComponent("CourseTermDrawer")!
  const _component_CourseBillDrawer = _resolveComponent("CourseBillDrawer")!
  const _component_AddCourseChapter = _resolveComponent("AddCourseChapter")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", _hoisted_9, "About " + _toDisplayString(_ctx.courseDetails?.course_name), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.courseDetails?.entities?.entity_name) + " [" + _toDisplayString(_ctx.courseDetails?.entities?.entity_short_name) + "] ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com004.svg" })
                    ]),
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.courseDetails?.course_type_info?.type_name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.courseDetails?.code), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("ul", _hoisted_23, [
            _createElementVNode("li", _hoisted_24, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 0 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "0",
                href: "#overview",
                role: "tab"
              }, " OverView ", 2)
            ]),
            _createElementVNode("li", _hoisted_25, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 1 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "1",
                href: "#course_configuration",
                role: "tab"
              }, " Course Configuration ", 2)
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 2 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "2",
                href: "#course_term",
                role: "tab"
              }, " Course Term ", 2)
            ]),
            _createElementVNode("li", _hoisted_27, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 3 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "3",
                href: "#course_bill",
                role: "tab"
              }, " Course Bill ", 2)
            ]),
            _createElementVNode("li", _hoisted_28, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 4 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "4",
                href: "#course_chapter",
                role: "tab"
              }, " Course Chapter ", 2)
            ]),
            _createElementVNode("li", _hoisted_29, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 5 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "5",
                href: "#unit_of_competency",
                role: "tab"
              }, " Unit of Competency ", 2)
            ]),
            (this.courseDetails?.update_status == 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 6 }]),
                    "data-bs-toggle": "tab",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setActiveTab($event))),
                    "data-tab-index": "6",
                    href: "#change_summery",
                    role: "tab"
                  }, " Change Summary ", 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    (_ctx.tabIndex === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 0 }]),
                id: "overview"
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.entity_type != 1011)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          (_ctx.actionEdit)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                "data-kt-drawer-toggle": "true",
                                "data-kt-drawer-target": "#kt_drawer_course_info",
                                id: "kt_drawer_course_info_button",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editcourse())),
                                type: "button",
                                class: "btn btn-primary p-2"
                              }, [
                                _createTextVNode(" Edit Course Info "),
                                _hoisted_37
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.courseDetails?.course_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.courseDetails?.tranche_single_info?.label), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.courseDetails?.entities?.entity_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.courseDetails?.course_type_info?.type_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.courseDetails?.course_sector_info?.sector_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.courseDetails?.code), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.courseDetails?.course_alias?.name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.courseDetails?.total_target_batches), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.courseDetails?.trainee_per_batch), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.courseDetails?.min_day_per_month), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.courseDetails?.total_course_cost), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.courseDetails?.unit_cost_total), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.courseDetails?.total_target_trainee), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.courseDetails?.min_age), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _hoisted_96,
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.courseDetails?.max_age), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.courseDetails?.course_objective), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _hoisted_104,
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.courseDetails?.entry_qualification), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      _hoisted_108,
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.courseDetails?.month), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      _hoisted_112,
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.courseDetails?.hour), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_115, [
                      _hoisted_116,
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.courseDetails?.day), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.courseDetails?.session), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _hoisted_124,
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.courseDetails?.term), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _hoisted_128,
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.courseDetails?.isStipendCourse == 1 ? 'Yes' : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _hoisted_132,
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.courseDetails?.course_skill_level?.name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_135, [
                      _hoisted_136,
                      _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.courseDetails?.isManagementCourse == 1 ? 'Yes' : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _hoisted_140,
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.courseDetails?.isEmploymentEligible == 1 ? 'Yes' : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      _hoisted_144,
                      _createElementVNode("div", _hoisted_145, [
                        _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.courseDetails?.isReassessmentEnabled == 1 ? 'Yes' : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _hoisted_148,
                      _createElementVNode("div", _hoisted_149, [
                        _createElementVNode("span", _hoisted_150, _toDisplayString(_ctx.courseDetails?.isTotCourse == 1 ? 'Yes' : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_151, [
                      _hoisted_152,
                      _createElementVNode("div", _hoisted_153, [
                        _createElementVNode("span", _hoisted_154, _toDisplayString(_ctx.courseDetails?.is_advanced_course == 1 ? 'Yes' : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_155, [
                      _hoisted_156,
                      _createElementVNode("div", _hoisted_157, [
                        _createElementVNode("span", _hoisted_158, _toDisplayString(_ctx.courseDetails?.certification_authority), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 1)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_159, [
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("div", _hoisted_161, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 1 }]),
                id: "course_configuration"
              }, [
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("div", _hoisted_163, [
                    (_ctx.entity_type != 1011)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                          (
                    _ctx.courseDetails?.course_config_info &&
                    _ctx.courseDetails?.batch_info?.length
                  )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.batchrunning())),
                                type: "button",
                                class: "btn btn-primary p-2"
                              }, [
                                _createTextVNode(" Edit Course Configuration "),
                                _hoisted_165
                              ]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                "data-kt-drawer-toggle": "true",
                                "data-kt-drawer-target": "#kt_drawer_course_config",
                                id: "kt_drawer_course_config_button",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editcourseConfig())),
                                type: "button",
                                class: "btn btn-primary p-2"
                              }, [
                                _createTextVNode(" Edit Course Configuration "),
                                _hoisted_166
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_167, [
                    _createElementVNode("div", _hoisted_168, [
                      _hoisted_169,
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.courseDetails?.course_config_info?.emp_bill_claim_perc), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_172, [
                      _hoisted_173,
                      _createElementVNode("div", _hoisted_174, [
                        _createElementVNode("span", _hoisted_175, _toDisplayString(_ctx.courseDetails?.course_config_info?.e_grace), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_176, [
                      _hoisted_177,
                      _createElementVNode("div", _hoisted_178, [
                        _createElementVNode("span", _hoisted_179, _toDisplayString(_ctx.courseDetails?.course_config_info
                        ?.dropout_rep_perc_per_batch), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_180, [
                      _hoisted_181,
                      _createElementVNode("div", _hoisted_182, [
                        _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.courseDetails?.course_config_info?.emp_bill_claim_perc), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_184, [
                      _hoisted_185,
                      _createElementVNode("div", _hoisted_186, [
                        _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.courseDetails?.course_config_info
                        ?.assessment_applicable == 1
                        ? 'yes'
                        : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_188, [
                      _hoisted_189,
                      _createElementVNode("div", _hoisted_190, [
                        _createElementVNode("span", _hoisted_191, _toDisplayString(_ctx.courseDetails?.course_config_info
                        ?.certification_applicable == 1
                        ? 'yes'
                        : 'No'), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 2)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_192, [
          _createElementVNode("div", _hoisted_193, [
            _createElementVNode("div", _hoisted_194, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 2 }]),
                id: "course_term"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_195, [
                    (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("div", _hoisted_197, [
                          (_ctx.entity_type != 1011)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                (_ctx.courseDetails?.batch_info?.length)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.batchrunning())),
                                      type: "button",
                                      class: "btn btn-primary p-2"
                                    }, [
                                      _createTextVNode(" Edit Course Term "),
                                      _hoisted_199
                                    ]))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editTerm())),
                                      "data-kt-drawer-toggle": "true",
                                      "data-kt-drawer-target": "#kt_drawer_course_term",
                                      id: "kt_drawer_course_term_button",
                                      type: "button",
                                      class: "btn btn-primary p-2"
                                    }, [
                                      _createTextVNode(" Edit Course Term "),
                                      _hoisted_200
                                    ]))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_201
                      ]),
                      _createElementVNode("div", _hoisted_202, [
                        _createElementVNode("div", _hoisted_203, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.terms, (val, i) => {
                            return (_openBlock(), _createElementBlock("div", { key: i }, [
                              _createElementVNode("div", _hoisted_204, [
                                _createElementVNode("div", _hoisted_205, [
                                  _createElementVNode("div", _hoisted_206, [
                                    _createElementVNode("div", _hoisted_207, [
                                      _createElementVNode("div", _hoisted_208, [
                                        _hoisted_209,
                                        _createVNode(_component_Field, {
                                          type: "number",
                                          value: i + 1,
                                          class: "form-control",
                                          readonly: ""
                                        }, null, 8, ["value"])
                                      ]),
                                      _createElementVNode("div", _hoisted_210, [
                                        _hoisted_211,
                                        _createVNode(_component_Field, {
                                          type: "number",
                                          modelValue: val.term_month,
                                          "onUpdate:modelValue": ($event: any) => ((val.term_month) = $event),
                                          readonly: "",
                                          class: "form-control"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_212, [
                                        _hoisted_213,
                                        _createVNode(_component_Field, {
                                          type: "number",
                                          modelValue: val.term_day,
                                          "onUpdate:modelValue": ($event: any) => ((val.term_day) = $event),
                                          readonly: "",
                                          class: "form-control"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_214, [
                                        _hoisted_215,
                                        _createVNode(_component_Field, {
                                          type: "number",
                                          modelValue: val.term_session,
                                          "onUpdate:modelValue": ($event: any) => ((val.term_session) = $event),
                                          readonly: "",
                                          class: "form-control"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_216, [
                                        _hoisted_217,
                                        _createVNode(_component_Field, {
                                          type: "number",
                                          modelValue: val.term_hour,
                                          "onUpdate:modelValue": ($event: any) => ((val.term_hour) = $event),
                                          readonly: "",
                                          class: "form-control"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_218, [
                                        _hoisted_219,
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": ($event: any) => ((val.class_type) = $event),
                                          disabled: "",
                                          class: "form-select form-select-lg mb-3",
                                          placeholder: "Select Class Type",
                                          style: {"width":"100%"},
                                          filterable: ""
                                        }, _hoisted_223, 8, _hoisted_220), [
                                          [_vModelSelect, val.class_type]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_224, [
                                        _hoisted_225,
                                        _createVNode(_component_Field, {
                                          type: "number",
                                          modelValue: val.week_session,
                                          "onUpdate:modelValue": ($event: any) => ((val.week_session) = $event),
                                          readonly: "",
                                          class: "form-control"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  ])
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 3)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_226, [
          _createElementVNode("div", _hoisted_227, [
            _createElementVNode("div", _hoisted_228, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 3 }]),
                id: "course_term"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_229, [
                    (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _createElementVNode("div", _hoisted_230, [
                        _createElementVNode("div", _hoisted_231, [
                          (_ctx.entity_type != 1011)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                (
                          this.bills.length > 0 &&
                          this.courseDetails?.training_payment_enrollment
                            .length === 0
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editBill())),
                                      "data-kt-drawer-toggle": "true",
                                      "data-kt-drawer-target": "#kt_drawer_course_bill",
                                      id: "kt_drawer_course_bill_button",
                                      type: "button",
                                      class: "btn btn-primary p-2"
                                    }, [
                                      _createTextVNode(" Edit Course Bill "),
                                      _hoisted_233
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                          this.courseDetails?.training_payment_enrollment
                            .length > 0
                        )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.billrunning())),
                                      type: "button",
                                      class: "btn btn-primary p-2"
                                    }, [
                                      _createTextVNode(" Edit Course Bill "),
                                      _hoisted_234
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_235
                      ]),
                      _createElementVNode("div", _hoisted_236, [
                        _createElementVNode("div", _hoisted_237, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bills, (v, i) => {
                            return (_openBlock(), _createElementBlock("div", { key: i }, [
                              _createElementVNode("div", _hoisted_238, [
                                _createElementVNode("div", _hoisted_239, [
                                  _hoisted_240,
                                  _createVNode(_component_Field, {
                                    modelValue: v.x_claim_milestone_id,
                                    "onUpdate:modelValue": ($event: any) => ((v.x_claim_milestone_id) = $event),
                                    type: "string",
                                    class: "form-control form-control-sm",
                                    readonly: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_241, [
                                  _hoisted_242,
                                  (i === 0)
                                    ? (_openBlock(), _createElementBlock("input", _hoisted_243))
                                    : _createCommentVNode("", true),
                                  (i === 1)
                                    ? (_openBlock(), _createElementBlock("input", _hoisted_244))
                                    : _createCommentVNode("", true),
                                  (i === 2)
                                    ? (_openBlock(), _createElementBlock("input", _hoisted_245))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_246, [
                                  _hoisted_247,
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    modelValue: v.claim_percentage,
                                    "onUpdate:modelValue": ($event: any) => ((v.claim_percentage) = $event),
                                    readonly: "",
                                    class: "form-control form-control-sm"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_248, [
                                  _hoisted_249,
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    modelValue: v.adj_adv_reduction_perc,
                                    "onUpdate:modelValue": ($event: any) => ((v.adj_adv_reduction_perc) = $event),
                                    readonly: "",
                                    class: "form-control form-control-sm"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _hoisted_250,
                                _createElementVNode("div", _hoisted_251, [
                                  _createElementVNode("label", _hoisted_252, [
                                    (v.claim_percentage)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_253, _toDisplayString((
                                  this.courseDetails.unit_cost_total *
                                  (v.claim_percentage / 100)
                                ).toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_254, " 00 "))
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  ])
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 4)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_255, [
          _createElementVNode("div", _hoisted_256, [
            _createElementVNode("div", _hoisted_257, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 4 }]),
                id: "course_chapter"
              }, [
                _createElementVNode("div", _hoisted_258, [
                  _hoisted_259,
                  _createElementVNode("div", _hoisted_260, [
                    _createElementVNode("div", _hoisted_261, [
                      (_ctx.entity_type != 1011)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            "data-kt-drawer-toggle": "true",
                            "data-kt-drawer-target": "#kt_drawer_course_chapter",
                            id: "kt_drawer_course_chapter_button",
                            type: "button",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addChapter && _ctx.addChapter(...args))),
                            class: "btn btn-primary p-2"
                          }, [
                            _createTextVNode(" Add Course Chapters "),
                            _hoisted_262
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_263,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseChapterData, (data, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("div", _hoisted_264, [
                        _createElementVNode("span", _hoisted_265, _toDisplayString(index + 1) + ". ", 1),
                        _createElementVNode("span", _hoisted_266, _toDisplayString(data?.chapter_name), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 5)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_267, [
          _createElementVNode("div", _hoisted_268, [
            _createElementVNode("div", _hoisted_269, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 5 }]),
                id: "unit_of_competency"
              }, [
                _createElementVNode("div", _hoisted_270, [
                  _hoisted_271,
                  _createElementVNode("div", _hoisted_272, [
                    _createElementVNode("div", _hoisted_273, [
                      (_ctx.entity_type != 1011)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            "data-kt-drawer-toggle": "true",
                            "data-kt-drawer-target": "#kt_drawer_unit_of_competency",
                            id: "kt_drawer_unit_of_competency_button",
                            type: "button",
                            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addUnitofCompetency && _ctx.addUnitofCompetency(...args))),
                            class: "btn btn-primary p-2"
                          }, [
                            _createTextVNode(" Add Unit of Competency "),
                            _hoisted_274
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_275,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unitOfCompetencyData, (data, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("div", _hoisted_276, [
                        _createElementVNode("span", _hoisted_277, _toDisplayString(index + 1) + ". ", 1),
                        _createElementVNode("span", _hoisted_278, _toDisplayString(data?.unit_name), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 6)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "card",
          key: _ctx.componentKey
        }, [
          _createElementVNode("div", _hoisted_279, [
            _createElementVNode("div", _hoisted_280, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 6 }]),
                id: "change_summery"
              }, [
                _createElementVNode("div", _hoisted_281, [
                  _createElementVNode("div", _hoisted_282, [
                    _createElementVNode("div", _hoisted_283, [
                      _createElementVNode("div", _hoisted_284, [
                        _hoisted_285,
                        (_ctx.entity_type == 1004)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_286, [
                              (_ctx.actionApprove)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    title: "Approve",
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.Approve())),
                                    class: "text-light btn btn-bg-success btn-active-color-primary btn-sm me-1"
                                  }, " Approve "))
                                : _createCommentVNode("", true),
                              (_ctx.actionReject)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    title: "Reject",
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.Reject())),
                                    class: "btn text-light btn-bg-danger btn-active-color-primary btn-sm"
                                  }, " Reject "))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.updateLogCourseInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
                            _hoisted_288,
                            _createElementVNode("table", _hoisted_289, [
                              _hoisted_290,
                              _createElementVNode("tbody", null, [
                                (_ctx.updateLogCourseInfo.course_name)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_291, [
                                      _hoisted_292,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_name), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.course_name), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.course_type_info)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_293, [
                                      _hoisted_294,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_type_info?.type_name), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.course_type_info), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.course_sector_info)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_295, [
                                      _hoisted_296,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_sector_info?.sector_name), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.course_sector_info), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.code)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_297, [
                                      _hoisted_298,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.code), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.code), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.course_alias_info)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_299, [
                                      _hoisted_300,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_alias?.name), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.course_alias_info), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.total_target_batches)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_301, [
                                      _hoisted_302,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.total_target_batches), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.total_target_batches), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.trainee_per_batch)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_303, [
                                      _hoisted_304,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.trainee_per_batch), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.trainee_per_batch), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.min_day_per_month)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_305, [
                                      _hoisted_306,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.min_day_per_month), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.min_day_per_month), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.total_course_cost)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_307, [
                                      _hoisted_308,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.total_course_cost), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.total_course_cost), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.total_target_trainee)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_309, [
                                      _hoisted_310,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.total_target_trainee), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.total_target_trainee), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.min_age)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_311, [
                                      _hoisted_312,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.min_age), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.min_age), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.pedagogy_level_nsda)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_313, [
                                      _hoisted_314,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.max_age), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.max_age), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.course_objective)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_315, [
                                      _hoisted_316,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_objective), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.course_objective), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.entry_qualification)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_317, [
                                      _hoisted_318,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.entry_qualification), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.entry_qualification), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.month)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_319, [
                                      _hoisted_320,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.month), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.month), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.hour)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_321, [
                                      _hoisted_322,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.hour), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.hour), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.day)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_323, [
                                      _hoisted_324,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.day), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.day), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.session)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_325, [
                                      _hoisted_326,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.session), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.session), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.term)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_327, [
                                      _hoisted_328,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.term), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.term), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.isStipendCourse)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_329, [
                                      _hoisted_330,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.isStipendCourse == 1 ? 'Yes' : 'No'), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.isStipendCourse == '1'
                              ? 'Yes'
                              : 'No'), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.isManagementCourse)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_331, [
                                      _hoisted_332,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.isManagementCourse == 1
                              ? 'Yes'
                              : 'No'), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.isManagementCourse == 1
                              ? 'Yes'
                              : 'No'), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.isEmploymentEligible)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_333, [
                                      _hoisted_334,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.isEmploymentEligible == 1
                              ? 'Yes'
                              : 'No'), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.isEmploymentEligible == 1
                              ? 'Yes'
                              : 'No'), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.isReassessmentEnabled)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_335, [
                                      _hoisted_336,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.isReassessmentEnabled == 1
                              ? 'Yes'
                              : 'No'), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.isReassessmentEnabled == 1
                              ? 'Yes'
                              : 'No'), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.isTotCourse)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_337, [
                                      _hoisted_338,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.isTotCourse == 1 ? 'Yes' : 'No'), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.isTotCourse == 1 ? 'Yes' : 'No'), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseInfo.certification_authority)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_339, [
                                      _hoisted_340,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.certification_authority), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseInfo?.certification_authority), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.updateLogCourseConfig)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_341, [
                            _hoisted_342,
                            _createElementVNode("table", _hoisted_343, [
                              _hoisted_344,
                              _createElementVNode("tbody", null, [
                                (_ctx.updateLogCourseConfig.e_grace)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_345, [
                                      _hoisted_346,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_config_info?.e_grace), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseConfig.e_grace), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseConfig.dropout_rep_perc_per_batch)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_347, [
                                      _hoisted_348,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_config_info
                              ?.dropout_rep_perc_per_batch), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseConfig.dropout_rep_perc_per_batch), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseConfig.emp_bill_claim_perc)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_349, [
                                      _hoisted_350,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_config_info
                              ?.emp_bill_claim_perc), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseConfig.emp_bill_claim_perc), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseConfig.assessment_applicable)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_351, [
                                      _hoisted_352,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_config_info
                              ?.assessment_applicable == 1
                              ? 'Yes'
                              : 'No'), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseConfig.assessment_applicable == '1'
                              ? 'Yes'
                              : 'No'), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.updateLogCourseConfig.certification_applicable)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_353, [
                                      _hoisted_354,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.courseDetails?.course_config_info
                              ?.certification_applicable == 1
                              ? 'Yes'
                              : 'No'), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.updateLogCourseConfig.certification_applicable ==
                            '1'
                              ? 'yes'
                              : 'No'), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.updateLogCourseTermFilter &&
                    _ctx.updateLogCourseTermFilter.length > 0
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_355, [
                            _hoisted_356,
                            _createElementVNode("table", _hoisted_357, [
                              _hoisted_358,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateLogCourseTermFilter, (info, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (info.id)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(this.courseDetails
                              ?.course_term_info, (data, i) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                            (data.id == info.id)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createElementVNode("tr", _hoisted_359, [
                                                    _createElementVNode("td", {
                                                      rowspan: info.count - 1
                                                    }, _toDisplayString(info?.term_no), 9, _hoisted_360)
                                                  ]),
                                                  (info.term_month)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_361, [
                                                        _hoisted_362,
                                                        _createElementVNode("td", null, _toDisplayString(data?.term_month), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.term_month), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.term_day)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_363, [
                                                        _hoisted_364,
                                                        _createElementVNode("td", null, _toDisplayString(data?.term_day), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.term_day), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.term_session)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_365, [
                                                        _hoisted_366,
                                                        _createElementVNode("td", null, _toDisplayString(data?.term_session), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.term_session), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.term_hour)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_367, [
                                                        _hoisted_368,
                                                        _createElementVNode("td", null, _toDisplayString(data?.term_hour), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.term_hour), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.class_type)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_369, [
                                                        _hoisted_370,
                                                        _createElementVNode("td", null, _toDisplayString(data?.class_type), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.class_type), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.week_session)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_371, [
                                                        _hoisted_372,
                                                        _createElementVNode("td", null, _toDisplayString(data?.week_session), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.week_session), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("tr", _hoisted_373, [
                                            _createElementVNode("td", _hoisted_374, _toDisplayString(info?.term_no), 1)
                                          ]),
                                          (info.term_month)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_375, [
                                                _hoisted_376,
                                                _hoisted_377,
                                                _createElementVNode("td", null, _toDisplayString(info?.term_month), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.term_day)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_378, [
                                                _hoisted_379,
                                                _hoisted_380,
                                                _createElementVNode("td", null, _toDisplayString(info?.term_day), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.term_session)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_381, [
                                                _hoisted_382,
                                                _hoisted_383,
                                                _createElementVNode("td", null, _toDisplayString(info?.term_session), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.term_hour)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_384, [
                                                _hoisted_385,
                                                _hoisted_386,
                                                _createElementVNode("td", null, _toDisplayString(info?.term_hour), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.class_type)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_387, [
                                                _hoisted_388,
                                                _hoisted_389,
                                                _createElementVNode("td", null, _toDisplayString(info?.class_type), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.week_session)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_390, [
                                                _hoisted_391,
                                                _hoisted_392,
                                                _createElementVNode("td", null, _toDisplayString(info?.week_session), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.updateLogCourseBill !== '' || _ctx.updateLogCourseBill.length > 0
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_393, [
                            _hoisted_394,
                            _createElementVNode("table", _hoisted_395, [
                              _hoisted_396,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateLogCourseBill, (info, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (info.id)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(this.courseDetails
                              ?.course_bill_info, (data, i) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                            (data.id == info.id)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createElementVNode("tr", _hoisted_397, [
                                                    _createElementVNode("td", {
                                                      rowspan: info.count
                                                    }, _toDisplayString(index + 1), 9, _hoisted_398)
                                                  ]),
                                                  (info.x_claim_milestone_id)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_399, [
                                                        _hoisted_400,
                                                        _createElementVNode("td", null, _toDisplayString(data?.x_claim_milestone_id), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.x_claim_milestone_id), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.x_training_milestone_id)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_401, [
                                                        _hoisted_402,
                                                        _createElementVNode("td", null, _toDisplayString(data?.x_training_milestone_id), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.x_training_milestone_id), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.claim_percentage)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_403, [
                                                        _hoisted_404,
                                                        _createElementVNode("td", null, _toDisplayString(data?.claim_percentage), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.claim_percentage), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (info.adj_adv_reduction_perc)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_405, [
                                                        _hoisted_406,
                                                        _createElementVNode("td", null, _toDisplayString(data?.adj_adv_reduction_perc), 1),
                                                        _createElementVNode("td", null, _toDisplayString(info?.adj_adv_reduction_perc), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("tr", _hoisted_407, [
                                            _createElementVNode("td", _hoisted_408, _toDisplayString(index + 1), 1)
                                          ]),
                                          (info.x_claim_milestone_id)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_409, [
                                                _hoisted_410,
                                                _hoisted_411,
                                                _createElementVNode("td", null, _toDisplayString(info?.x_claim_milestone_id), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.x_training_milestone_id)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_412, [
                                                _hoisted_413,
                                                _hoisted_414,
                                                _createElementVNode("td", null, _toDisplayString(info?.x_training_milestone_id), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.claim_percentage)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_415, [
                                                _hoisted_416,
                                                _hoisted_417,
                                                _createElementVNode("td", null, _toDisplayString(info?.claim_percentage), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (info.adj_adv_reduction_perc)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_418, [
                                                _hoisted_419,
                                                _hoisted_420,
                                                _createElementVNode("td", null, _toDisplayString(info?.adj_adv_reduction_perc), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _hoisted_421
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_CourseInfoDrawer),
    _createVNode(_component_CourseConfigDrawer),
    _createVNode(_component_CourseTermDrawer),
    _createVNode(_component_CourseBillDrawer),
    _createVNode(_component_AddCourseChapter)
  ], 64))
}